module.exports = __webpack_public_path__ + "assets/cta-decoration-br.d579fb10.png";